<template>
  <table border="1" class="gantt-header">
    <template v-if="ganntHeaderMode && ganntHeaderMode === 'day'">
      <tr>
        <template v-for="item in headerData">
          <th
            v-for="(subitem, index) in item.children"
            :key="index"
            :colspan="subitem.dayList.length"
          >
            {{ item.year }}
          </th>
        </template>
      </tr>

      <tr>
        <template v-for="item in headerData">
          <th
            v-for="(subitem, index) in item.children"
            :key="index"
            :colspan="subitem.dayList.length"
          >
            {{ subitem.month }}
          </th>
        </template>
      </tr>

      <tr>
        <template v-for="item in headerData">
          <template v-for="subitem in item.children">
            <th v-for="(day, index) in subitem.dayList" :key="index">
              <div class="th-size" :class="setRedText(day)">
                {{ day }}
              </div>
            </th>
          </template>
        </template>
      </tr>
    </template>

    <template
      v-if="
        ganntHeaderMode &&
        (ganntHeaderMode === 'week' || ganntHeaderMode === 'month')
      "
    >
      <tr>
        <template v-for="(item, index) in headerData" :key="index">
          <th :colspan="item.end - item.start + 1">
            <div
              :class="[
                setClassName(ganntHeaderMode),
                ganntHeaderMode === 'week' ? 'un-day' : 'un-week',
              ]"
            >
              {{ item.year }}
            </div>
          </th>
        </template>
      </tr>

      <tr>
        <template v-for="item in headerData">
          <th v-for="(day, index) in item.end - item.start + 1" :key="index">
            <div
              class="th-size un-day"
              :class="[setClassName(ganntHeaderMode)]"
            >
              {{ index + item.start }}
            </div>
          </th>
        </template>
      </tr>
    </template>
  </table>
</template>

<script>
import { defineComponent, inject, reactive, watch } from "vue";

export default defineComponent({
  props: { mode: String, header: Object },
  setup(props, context) {
    const setRedText = (name) => {
      const MODECLASSNAME = {
        周: "th-red-text",
        补: "th-red-text",
        假: "th-blue-text",
        六: "th-green-text",
        日: "th-green-text",
      };

      const className = MODECLASSNAME[name];

      if (className) {
        return className;
      }

      return "";
    };

    const setClassName = (mode) => {
      const MODECLASSNAME = {
        week: "",
        month: "month-mode",
      };

      const className = MODECLASSNAME[mode];

      if (className) {
        return className;
      }

      return "";
    };

    const ganntHeaderMode = inject("ganntHeaderMode", null);

    const headerData = reactive([]);

    watch(
      () => props.header,
      (val) => {
        headerData.length = 0;
        headerData.push(...val);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      props,
      headerData,
      ganntHeaderMode,
      setRedText,
      setClassName,
    };
  },
});
</script>

<style lang="less" scoped>
.gantt-header {
  th {
    text-align: center;
    padding: 3px 7px;
    .th-size {
      width: 16px;
    }
    .th-red-text {
      color: red;
    }
    .th-blue-text {
      color: #00bfff;
    }
    .th-green-text {
      color: #00008B;
    }
    .un-day {
      height: 35px;
      line-height: 35px;
      text-align: center;
    }
    .month-mode {
      width: 60px;
    }
    .un-week {
      line-height: 35px;
      text-align: center;
      width: unset;
    }
  }
}
</style>
